export enum PolicyTypeId {
  TYPE_1 = 1,
  TYPE_2 = 2,
  TYPE_3 = 3,
}
